<template>
  <div v-if="data?.content" class="note-help-form-item">
    <div class="note-content">
      <div class="note-border"></div>
      <div class="note-text" v-html="data.content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NoteHelp',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style scoped>
.note-help-form-item {
  padding: 12px 16px;
}

.note-content {
  display: flex;
  align-items: stretch;
  background: #E8F4FD;
  border-left: 4px solid #81B0E1;
  border-radius: 0;
  width: 100%;
}

.note-border {
  display: none;
}

.note-text {
  flex: 1;
  padding: 9px 16px;
  color: #333;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>

<style>
/* Rich text styles for NoteHelp content */
.note-help-form-item .note-text h1,
.note-help-form-item .note-text h2,
.note-help-form-item .note-text h3 {
  margin: 0;
  font-weight: 600;
}

.note-help-form-item .note-text h1 { font-size: 18px; }
.note-help-form-item .note-text h2 { font-size: 16px; }
.note-help-form-item .note-text h3 { font-size: 15px; }

.note-help-form-item .note-text ul,
.note-help-form-item .note-text ol {
  margin: 0;
  padding-left: 0;
  list-style: none;
  counter-reset: item;
}

.note-help-form-item .note-text li {
  margin: 0;
  padding-left: 21px;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  position: relative;
}

.note-help-form-item .note-text ul > li::before {
  content: "• ";
  position: absolute;
  left: 6px;
}

.note-help-form-item .note-text ol {
  counter-reset: item;
}

.note-help-form-item .note-text ol > li {
  counter-increment: item;
}

.note-help-form-item .note-text ol > li::before {
  content: counter(item) ". ";
  position: absolute;
  left: 0;
}

.note-help-form-item .note-text strong,
.note-help-form-item .note-text b {
  font-weight: 700;
}

.note-help-form-item .note-text em,
.note-help-form-item .note-text i {
  font-style: italic;
}

.note-help-form-item .note-text u {
  text-decoration: underline;
}

.note-help-form-item .note-text a {
  color: #004879;
  text-decoration: underline;
}
</style>
